import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })export class ActionButtonsAcsses {
  user;
  rowActionButtonsSub = new Subject;
  topbarActionButtonSub = new Subject;
  constructor(public auth: AuthService,
  ) {

  }

  public rowActionButtons(rowActionButtons) {
    let _rowActionButtons = rowActionButtons.slice()
    this.auth.user$.subscribe(user => {
      this.user = user;
      // console.log(this.rowActionButtons.filter(b=> b.icon == 'edit').length)
      if (_rowActionButtons.filter(b => b.icon == 'edit').length == 0 && this.auth.canEdit(this.user)) {
        let eIndex = rowActionButtons.findIndex(b => b.icon == 'edit')
        if (eIndex > -1) {
          _rowActionButtons.push(rowActionButtons[eIndex]);
        }
      } else if (!this.auth.canEdit(this.user)) {
        let eIndex = _rowActionButtons.findIndex(b => b.icon == 'edit')
        if (eIndex > -1) {
          _rowActionButtons.splice(eIndex, 1);
        }
      }


      if (_rowActionButtons.filter(b => b.icon == 'clear').length == 0 && this.auth.canDelete(this.user)) {
        let index = rowActionButtons.findIndex(b => b.icon == 'clear')
        if (index > -1) {
          _rowActionButtons.push(rowActionButtons[index]);
        }
      } else if (!this.auth.canDelete(this.user)) {
        let index = _rowActionButtons.findIndex(b => b.icon == 'clear')
        if (index > -1) {
          _rowActionButtons.splice(index, 1);
        }
      }

      this.rowActionButtonsSub.next(_rowActionButtons)
    })
  }


  public topbarActionButton( topbarActionButton) {
    let _topbarActionButton = topbarActionButton.slice()

    this.auth.user$.subscribe(user => {
      this.user = user;

      if (_topbarActionButton.filter(b => b.icon == 'add').length == 0 && this.auth.canEdit(this.user)) {
        let aIndex = topbarActionButton.findIndex(b => b.icon == 'add')
        if (aIndex > -1) {
          _topbarActionButton.push(topbarActionButton[aIndex]);
        }
      } else if (!this.auth.canEdit(this.user)) {
        let aIndex = _topbarActionButton.findIndex(b => b.icon == 'add')
        if (aIndex > -1) {
          _topbarActionButton.splice(aIndex, 1);
        }
      }
      this.topbarActionButtonSub.next(_topbarActionButton)
    })
  }
}